"use client";

export default function GlobalError({ reset }: { reset: () => void }) {
  return (
    <html lang="zh-CN">
      <body style={{ margin: 0, background: "#0b0d10", color: "#f2f5f7", fontFamily: "system-ui" }}>
        <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
          <section style={{ maxWidth: 520, textAlign: "center" }}>
            <h1>应用暂时无法显示</h1>
            <p style={{ color: "#9ba7ae" }}>请重试；如果问题持续出现，请记录时间并联系维护人员。</p>
            <button onClick={reset} style={{ marginTop: 16, padding: "10px 20px", borderRadius: 999 }}>
              重新加载
            </button>
          </section>
        </main>
      </body>
    </html>
  );
}
